import { cn } from "@/lib/utils";
import { useAppContext } from "@/providers/app-context";
import { BotIcon, MessageSquareIcon } from "lucide-react";
import React from "react";

type Mode = "assistant" | "project-chats";

const Pill = ({
  active,
  onClick,
  icon,
  label,
}: {
  active: boolean;
  onClick?: () => void;
  icon: React.ReactNode;
  label: string;
}) => (
  <button
    type="button"
    disabled={active}
    onClick={onClick}
    className={cn(
      "flex items-center gap-x-1 rounded-full border px-2.5 py-1 text-xs transition-colors",
      active
        ? "border-cf-foreground bg-cf-foreground/10 text-cf-foreground"
        : "border-transparent text-muted-foreground hover:border-gray-200 hover:bg-gray-50 hover:text-foreground",
    )}
  >
    {icon}
    <span className="truncate">{label}</span>
  </button>
);

export const SidePanelSwitcher = ({ mode }: { mode: Mode }) => {
  const {
    openAgent,
    openProjectChatPanel,
    currentViewedProject,
    projectChatPanelProject,
  } = useAppContext();

  const projectForChats = projectChatPanelProject ?? currentViewedProject;

  if (mode === "assistant" && !projectForChats) return null;

  return (
    <div className="flex items-center gap-x-1">
      <Pill
        active={mode === "assistant"}
        onClick={mode === "assistant" ? undefined : () => openAgent()}
        icon={<BotIcon className="h-3.5 w-3.5" />}
        label="Assistant"
      />
      {projectForChats && (
        <Pill
          active={mode === "project-chats"}
          onClick={
            mode === "project-chats"
              ? undefined
              : () => openProjectChatPanel(projectForChats)
          }
          icon={<MessageSquareIcon className="h-3.5 w-3.5" />}
          label={`Chats · ${projectForChats.name ?? "Project"}`}
        />
      )}
    </div>
  );
};
